import { AnimatePresence, m } from "framer-motion";
import { authClient } from "../../lib/auth-client";
import { capitalizeName } from "../../lib/format";

interface ImpersonationBannerProps {
	isImpersonating: boolean;
	user: {
		id: string;
		name?: string | null;
		email?: string;
	};
}

export function ImpersonationBanner({
	isImpersonating,
	user,
}: ImpersonationBannerProps) {
	const handleStopImpersonating = async () => {
		try {
			const result = await authClient.admin.stopImpersonating();
			if (result.error) {
				console.error("Stop impersonating failed:", result.error);
			}
		} catch (error) {
			console.error("Stop impersonating error:", error);
		}
		window.location.href = "/admin/users";
	};

	return (
		<AnimatePresence>
			{isImpersonating && (
				<m.div
					initial={{ height: 0, opacity: 0 }}
					animate={{ height: "auto", opacity: 1 }}
					exit={{ height: 0, opacity: 0 }}
					transition={{ duration: 0.2, ease: "easeOut" }}
					className="overflow-hidden border-b border-amber-500/40 bg-amber-500/10"
				>
					<div className="mx-auto max-w-7xl px-4 sm:px-6">
						<div className="flex h-9 items-center justify-between">
							<div className="flex items-center gap-2 font-mono text-sm uppercase tracking-[0.14em] text-amber-600 dark:text-amber-400">
								<span className="relative flex size-1.5">
									<span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber-500 opacity-70" />
									<span className="relative inline-flex size-1.5 rounded-full bg-amber-500" />
								</span>
								Impersonating{" "}
								<span className="text-foreground">
									{user.email || capitalizeName(user.name) || user.id}
								</span>
							</div>
							<button
								type="button"
								onClick={handleStopImpersonating}
								className="font-mono text-sm uppercase tracking-[0.14em] text-amber-600 transition-colors hover:text-amber-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 focus-visible:ring-offset-2 focus-visible:ring-offset-background dark:text-amber-400 dark:hover:text-amber-300"
							>
								&larr; Back to admin
							</button>
						</div>
					</div>
				</m.div>
			)}
		</AnimatePresence>
	);
}
